export default {
    routeBusinessStockDeliveryInformView: {
        Basic: 'Account Information',
        Delivery: 'Outbound notice Order No.',
        Outbound: 'Outbound logic warehouse code',
        Name: 'Outbound logic warehouse name',
        Issue: 'Outbound Type',
        status: 'Outbound Status',
        Buyer: 'Buyer Comments',
        Merchant: 'Seller Comments',
        Logistics: 'Logistics',
        business: 'Logistics Business',
        Consignee: 'Full Name',
        Contact: 'Contact Phone',
        Shipping: 'Shipping Address',
        Creation: 'Creation Time',
        Created: 'Created By',
        Associated: 'Related Documents',
        Pre: 'Preceding Order No.',
        Internal: 'CSG Order No.',
        Third: 'Customer Order No.',
        result: 'Outbound result Order No.',
        View: 'View More',
        Product: 'Product Details',
        code: 'Product Code',
        SKU: 'SKU Name',
        SKUcode: 'SKU',
        Shipment: 'Quantity to be shipped',
        Quantity: 'Quantity Shipped',
        Productname: 'Product Name',
        Total: 'Total quantity to be shipped',
        shipped: 'Total Quantity Shipped',
        go: 'Historical Related Resend Order',
    }
};
